import axios from "axios"
import { Headers, IResponse } from "./networking"
import { getDateRange } from "./date-range.store"

let API: ReturnType<typeof axios.create>

const initializeAPI = (baseURL: string) => {
  API = axios.create({
    baseURL,
  })

  API.interceptors.request.use((config) => {
    const { startDate, endDate } = getDateRange()
    if (config.method?.toLowerCase() === 'get' && startDate && endDate) {
      config.params = {
        ...config.params,
        startDate,
        endDate
      }
    }

    return config
  })

  return API
}

API = axios.create({
  baseURL: 'bemap',
})

const consumer = async (method: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE', endpoint: string, payload?: any, id?: any): Promise<IResponse> => {
  const url = id ? `${endpoint}/${id}` : endpoint;

  try {
    let response;
    switch (method) {
      case 'GET':
        response = await API.get(url, await Headers.key());
        break;
      case 'POST':
        response = await API.post(url, payload, await Headers.key());
        break;
      case 'PATCH':
        response = await API.patch(url, payload, await Headers.key());
        break;
      case 'PUT':
        response = await API.put(url, payload, await Headers.key());
        break;
      case 'DELETE':
        response = await API.delete(url, await Headers.key());
        break;
    }
    return {
      statusCode: response.status,
      message: response.data?.message || [],
      error: undefined
    };
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
}

const postFile = async (endpoint: string, payload?: any, id?: any): Promise<IResponse> => {
  const url = id ? `${endpoint}/${id}` : endpoint;

  try {
    const response = await API.post(url, payload, await Headers.file());
    return {
      statusCode: response.status,
      message: response.data?.message || [],
      error: undefined
    };
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
}

export { API, consumer, postFile, initializeAPI } 